// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1L7vg","clinicsSelect":"styles_clinicsSelect__24yjA"};